import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./features/authentication";
import { PageContainer } from "./layouts/page-container";

export const App = () => {
  return (
    <AuthProvider>
      <PageContainer>
        <Suspense>
          <Outlet />
        </Suspense>
      </PageContainer>
    </AuthProvider>
  );
};
